document.addEventListener("DOMContentLoaded", function() {
    // Options 
    const options1 = {
        root: null, 
        rootMargin: "0px",
        threshold: 0.5 
    };

    const options2 = {
        root: null, 
        rootMargin: "0px",
        threshold: 0.35 
    };

    const options3 = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2
    };


    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
             
                entry.target.classList.add("visible");
                observer.unobserve(entry.target); 
            }
        });
    };

    // create IntersectionObservers
    const observer1 = new IntersectionObserver(callback, options1); // threshold 50%
    const observer2 = new IntersectionObserver(callback, options2); // threshold 35%
    const observer3 = new IntersectionObserver(callback, options3); // threshold 25%

    
    const elements_th50 = document.querySelectorAll(".flexbox-vertical__three_pic_section, .content_wrapper_top__two_pic_section, .about_us__two_pictures_section_image_wrapper_top, .about_us__two_pictures_section_image_wrapper_bottom");
    elements_th50.forEach(element => observer1.observe(element));

    const elements_th35 = document.querySelectorAll(".flexbox__palini_logo_section, .logo__two_pic_section, .about_us__product_section, .inner-container__materials_section, .info_section_container");
    elements_th35.forEach(element => observer2.observe(element));

    const elements_th25 = document.querySelectorAll(".flexbox-horizontal__three_pic_section");
    elements_th25.forEach(element => observer3.observe(element));
    
});



